import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CbSideBarModule } from '@app/shared/components/side-bar/side-bar.module';
import { CbDialogModule } from '@app/shared/components/dialog/dialog.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BusinessEntitiesComponent } from './business-entities.component';
import { BusinessEntityDetailsComponent } from './tabs/business-entity-details/business-entity-details.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CbFormsModule } from '@app/shared/components/forms/forms.module';
import { CbHubTableModule } from '@app/shared/components/table/table.module';
import { CbInfoMessageModule, CbLoadingSpinnerModule, CbTableModule } from 'cb-hub-lib';
import { CbWaitForModule } from '@app/shared/directives/wait-for/wait-for.module';
import { DefaultInstallerDialogComponent } from './tabs/default-installers/default-installer-dialog/default-installer-dialog.component';
import { DefaultSupplierDialogComponent } from './tabs/default-suppliers/default-supplier-dialog/default-supplier-dialog.component';
import { BusinessEntityDefaultInstallersComponent } from './tabs/default-installers/default-installers.component';
import { BusinessEntityDefaultSuppliersComponent } from './tabs/default-suppliers/default-suppliers.component';
import { CbDisplayValueModule } from '@app/shared/components/display-value/display-value.module';
import { BuildContingencyRecordDialogComponent } from './tabs/business-entity-contingencies/business-entity-contingency-dialog/business-entity-contingency-dialog.component';
import { BusinessEntityBuildContingencyRecordsComponent } from './tabs/business-entity-contingencies/business-entity-contingencies.component';

@NgModule({
    declarations: [
        BusinessEntitiesComponent,
        BusinessEntityDetailsComponent,
        DefaultInstallerDialogComponent,
        DefaultSupplierDialogComponent,
        BuildContingencyRecordDialogComponent,
        BusinessEntityBuildContingencyRecordsComponent,
        BusinessEntityDefaultInstallersComponent,
        BusinessEntityDefaultSuppliersComponent
    ],
    imports: [
        CbWaitForModule,
        CbDisplayValueModule,
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTabsModule,
        MatTooltipModule,
        CbSideBarModule,
        CbDialogModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatDividerModule,
        InfiniteScrollDirective,
        MatTableModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
        MatAutocompleteModule,
        CbFormsModule,
        CbHubTableModule,
        CbTableModule
    ],
    exports: [
        BusinessEntitiesComponent,
        DefaultInstallerDialogComponent,
        DefaultSupplierDialogComponent,
        BusinessEntityDefaultInstallersComponent,
        BusinessEntityDefaultSuppliersComponent,
        BuildContingencyRecordDialogComponent,
        BusinessEntityBuildContingencyRecordsComponent
    ]
})
export class BusinessEntitiesSettingsModule { }
